// Widget registry and types
// Provides a way to register dashboard widgets dynamically.
// Follow TypeScript guidelines: use interfaces, explicit return types.

import { IRutinInfo } from '../../Types/RutinInfoType';
import { rutinInfos } from '../Delsystem/_Common/Const/RutinInfo';
import { IconType } from '../../BaseComponents/Icon/Utils/IconDefinitions';
import { IWidgetContentProps } from './Components/Widget/Widget';
import {
  STARTED_ROUTINES_ICON_TYPE,
  STARTED_ROUTINES_TITLE,
} from '../StartPanel/Components/Cards/StartedRoutines/StartedRoutines';
import { StartedRoutinesWidget } from '../StartPanel/Components/Cards/StartedRoutines/StartedRoutinesPanel';
import { StatistikrapporteringWidget } from '../Delsystem/Bokning/ObjektVyer/Statistikrapportering/StatistikrapporteringWidget';
import { KalenderWidget } from '../Delsystem/Bokning/Rutiner/Kalender/Components/KalenderWidget';
import { MeQuery } from '../Delsystem/Bokning/Rutiner/Kalender/Queries/MeQuery/_QueryTypes/MeQuery';
import { IWidgetVisibilityOption } from './useWidgetVisibility';

export type WidgetSize = 'standard' | 'doubleWidth' | 'doubleHeight';

export interface IWidget {
  /** Unique id used as key when rendering */
  id: string;
  /** Title shown in EDPanel header */
  title: string;
  /** Optional icon to render in EDPanel avatar */
  iconType?: IconType;
  /** Optional rutin info */
  routine?: IRutinInfo;
  /** Size hint, if the screen size allows it */
  size?: WidgetSize;
  /** React component rendered inside the EDPanel body */
  component: React.ComponentType<IWidgetContentProps>;
  /** Optional test id for automation */
  testId?: string;
  /** Whether the widget should be hidden */
  isHidden?: (meData: MeQuery | undefined) => boolean | undefined;
  /**UseSysoption*/
  visibilityOption?: IWidgetVisibilityOption;
}

export const widgets: Record<string, IWidget> = {
  StartedRoutines: {
    id: 'StartedRoutines',
    title: STARTED_ROUTINES_TITLE,
    iconType: STARTED_ROUTINES_ICON_TYPE,
    size: 'standard',
    component: StartedRoutinesWidget,
    testId: 'standardWidget',
  },
  Statistikrapportering: {
    id: 'Statistikrapportering',
    title: 'Statistikrapportering',
    iconType: 'delsystem_bokning',
    routine: rutinInfos.rtnStatistikrapporteringNew,
    size: 'standard',
    component: StatistikrapporteringWidget,
    testId: 'StatistikrapporteringWidget',
    visibilityOption: {
      subSystemCode: 'BO',
      optionKey: 'BO_NA_DASHBOARDS',
      allowedValues: ['Statistik'],
    },
  },
  Kalender: {
    id: 'Kalender',
    title: 'Min kalender',
    iconType: 'delsystem_bokning',
    routine: rutinInfos.rtnWebKalender,
    size: 'standard',
    component: KalenderWidget,
    testId: 'KalenderWidget',
    visibilityOption: {
      subSystemCode: 'BO',
      optionKey: 'BO_NA_DASHBOARDS',
      allowedValues: ['Kalender'],
    },
    isHidden: meData => {
      const hasLoggedInUserResource =
        String(meData?.me?.[0]?.userBookingID ?? '').trim() !== '';
      return !hasLoggedInUserResource;
    },
  },
};
